<template>
  <div v-if="solicitor != null" class="border-2 border-gray-800">
    <div class="text-base bg-gray-800 text-white px-4 py-3 flex items-center">
      Solicitor / Conveyancer - if known
      <img src="https://cdn2.iconfinder.com/data/icons/officeicons/PNG/48/Help.png" 
        v-tooltip.top="{ content: 'Your broker can recommend a solicitor if you don\'t have one.' }"
        class="ml-4 w-4" />

      <a href="#" @click.prevent="showThirdPartyModal"
        v-if="$store.state.view == 'broker'"
        class="text-white underline ml-4">Copy from a previous solicitor</a>
    </div>

    <div class="p-4">

      <div class="flex flex-wrap">
        <div class="w-full lg:w-1/3 pr-0 lg:pr-3 mt-8 lg:mt-0">
          <InputText label="Company name"
            propertyKey="string1"
            :value="solicitor.string1"
            :updateValue="updateValue" />
        </div>
      </div>

      <div class="flex flex-wrap label-line">
        <div class="w-full lg:w-1/3 pr-0 lg:pr-3 mt-8 lg:mt-0">
          <TitleSelector 
            label="Contact person title"
            propertyKey="contact_title"
            :value="solicitor.contact_title"
            :updateValue="updateValue"></TitleSelector>
        </div>

        <div class="w-full lg:w-1/3 pr-0 lg:pr-3 mt-8 lg:mt-0">
          <InputText label="First name" 
            propertyKey="contact_first"
            :value="solicitor.contact_first"
            :updateValue="updateValue" />
        </div>

        <div class="w-full lg:w-1/3 pr-0 lg:pr-3">
          <InputText label="Surname" 
            propertyKey="contact_last"
            :value="solicitor.contact_last"
            :updateValue="updateValue" />
        </div>
      </div>

      <div class="flex flex-wrap label-line">
        <div class="w-full lg:w-1/3 pr-0 lg:pr-3 mt-8 lg:mt-0">
          <InputPhone label="Work phone number" 
            propertyKey="phone"
            :value="solicitor.phone"
            :updateValue="updateValue" />
        </div>

        <div class="w-full lg:w-1/3 pr-0 lg:pr-3 mt-8 lg:mt-0">
          <InputPhone label="Mobile number" 
            propertyKey="phone_mobile"
            :value="solicitor.phone_mobile"
            :updateValue="updateValue" />
        </div>

        <div class="w-full lg:w-1/3 pr-0 lg:pr-3 mt-8 lg:mt-0">
          <InputEmail label="Email" 
            propertyKey="email"
            :value="solicitor.email"
            :updateValue="updateValue" />
        </div>
      </div>

      <div class="flex flex-wrap label-line">
        <div class="w-full lg:w-1/3 pr-0 lg:pr-3 mt-8 lg:mt-0">
          <InputText label="Address" 
            propertyKey="address"
            :value="solicitor.address"
            :updateValue="updateValue" />
        </div>

        <div class="w-full lg:w-1/3 pr-0 lg:pr-3 mt-8 lg:mt-0">
          <InputText label="Suburb" 
            propertyKey="suburb"
            objectType="thirdParty"
            :value="solicitor.suburb"
            :updateValue="updateValue" />
        </div>

        <div class="w-full lg:w-1/3 pr-0 lg:pr-3 mt-8 lg:mt-0">
          <InputPostcode label="Postcode" 
            propertyKey="postcode"
            :value="solicitor.postcode"
            :updateValue="updateValue" />
        </div>
      </div>

      <div class="flex flex-wrap label-line">
        <div class="w-full lg:w-1/3 pr-0 lg:pr-3">
          <StateSelector
            propertyKey="state_id"
            :value="solicitor.state_id"
            :updateValue="updateValue" />
        </div>
      </div>

    </div>

    <ThirdPartyModal />
  </div>
</template>

<script>
  import TitleSelector    from '@/shared/components/form/TitleSelector'
  import InputText        from '@/shared/components/form/InputText'
  import InputPostcode    from '@/shared/components/form/InputPostcode'
  import InputPhone       from '@/shared/components/form/InputPhone'
  import InputEmail       from '@/shared/components/form/InputEmail'
  import StateSelector    from '@/shared/components/form/StateSelector'
  import ThirdPartyModal  from '@/shared/components/modals/ThirdPartyModal'

  export default {

    components: {
      TitleSelector,
      InputText,
      InputPhone,
      InputPostcode,
      InputEmail,
      StateSelector,
      ThirdPartyModal
    },

    data () {
      return {
        solicitor : null,
      }
    },

    created() {
      this.getThirdParty({
        clientId: this.$route.params.clientId,
        type    : 1
      }, (thirdParty) => {
        this.solicitor = thirdParty
      })
    },

    methods : {
      updateValue(params) {
        this.updateThirdParty(this.solicitor, 1, params.key, params.value)
      },

      showThirdPartyModal() {
        this.$modal.show('third-party-modal', { 
          type      : 1,
          label     : 'Solicitor',
          onSelected: this.onSelected
        })
      },

      onSelected(thirdPartyId) {
        // client would have the third party created already, so post a function to copy
        this.apiPost({
          clientId    : this.$route.params.clientId,
          thirdPartyId: thirdPartyId,
        }, 'third-party/copy', (thirdParty) => {
          this.solicitor = thirdParty
        })
      }
    }
  }
</script>